"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityDataChunkCodec = void 0;
const user_data_api_1 = require("@moojo/user-data-api");
const sdk_error_1 = require("../sdk-error");
const stable_stringify_1 = require("../utils/stable-stringify");
const resolve_codec_error_1 = require("./resolve-codec-error");
/**
 * Encodes and decodes objects by given parsing schema to and from data chunks.
 * This codec is mostly used for data interactions with User Data Nodes.
 *
 * TODO:
 * use more efficient serialization (protobufs?)
 * make more generic, we have a stack of transformers here: schema -> serialize -> encrypt -> transfer-encode
 * if encryption schema changes - versioning is needed.
 */
exports.entityDataChunkCodec = {
    toChunk: (encryptionKey, data, parser) => {
        try {
            const parsed = parser.parse(data);
            const json = (0, stable_stringify_1.stableStringify)(parsed);
            if (!json) {
                throw new sdk_error_1.SdkError('data_encoding_error', 'Serialization failed');
            }
            let content = Buffer.from(json, 'utf8');
            if (encryptionKey) {
                content = encryptionKey.encrypt(content);
            }
            return {
                // TODO: change DataChunkContent to accept text and not only base64
                content: user_data_api_1.DataChunkContent.parse(content.toString('base64')),
                tags: {
                // version can go here
                },
            };
        }
        catch (e) {
            throw (0, resolve_codec_error_1.resolveCodecError)(e);
        }
    },
    fromChunk: (decryptionKey, { content }, parser) => {
        try {
            const rawContent = Buffer.from(content, 'base64');
            const clearContent = decryptionKey ? decryptionKey.decrypt(rawContent) : rawContent;
            const clearText = clearContent.toString('utf-8');
            return parser.parse(JSON.parse(clearText));
        }
        catch (e) {
            throw (0, resolve_codec_error_1.resolveCodecError)(e);
        }
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1jaHVuay1jb2RlYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb2RlYy9kYXRhLWNodW5rLWNvZGVjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHdEQUFrRTtBQUVsRSw0Q0FBdUM7QUFDdkMsZ0VBQTJEO0FBQzNELCtEQUF5RDtBQUV6RDs7Ozs7Ozs7R0FRRztBQUNVLFFBQUEsb0JBQW9CLEdBQUc7SUFDbEMsT0FBTyxFQUFFLENBQUksYUFBb0MsRUFBRSxJQUFPLEVBQUUsTUFBbUIsRUFBYSxFQUFFO1FBQzVGLElBQUksQ0FBQztZQUNILE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUE7WUFDakMsTUFBTSxJQUFJLEdBQUcsSUFBQSxrQ0FBZSxFQUFDLE1BQU0sQ0FBQyxDQUFBO1lBQ3BDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztnQkFDVixNQUFNLElBQUksb0JBQVEsQ0FBQyxxQkFBcUIsRUFBRSxzQkFBc0IsQ0FBQyxDQUFBO1lBQ25FLENBQUM7WUFFRCxJQUFJLE9BQU8sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQTtZQUN2QyxJQUFJLGFBQWEsRUFBRSxDQUFDO2dCQUNsQixPQUFPLEdBQUcsYUFBYSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsQ0FBQTtZQUMxQyxDQUFDO1lBQ0QsT0FBTztnQkFDTCxtRUFBbUU7Z0JBQ25FLE9BQU8sRUFBRSxnQ0FBZ0IsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztnQkFDM0QsSUFBSSxFQUFFO2dCQUNKLHNCQUFzQjtpQkFDdkI7YUFDRixDQUFBO1FBQ0gsQ0FBQztRQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7WUFDWCxNQUFNLElBQUEsdUNBQWlCLEVBQUMsQ0FBQyxDQUFDLENBQUE7UUFDNUIsQ0FBQztJQUNILENBQUM7SUFFRCxTQUFTLEVBQUUsQ0FBSSxhQUFxQyxFQUFFLEVBQUUsT0FBTyxFQUFhLEVBQUUsTUFBbUIsRUFBSyxFQUFFO1FBQ3RHLElBQUksQ0FBQztZQUNILE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLFFBQVEsQ0FBQyxDQUFBO1lBQ2pELE1BQU0sWUFBWSxHQUFHLGFBQWEsQ0FBQyxDQUFDLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFBO1lBQ25GLE1BQU0sU0FBUyxHQUFHLFlBQVksQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUE7WUFDaEQsT0FBTyxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQTtRQUM1QyxDQUFDO1FBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztZQUNYLE1BQU0sSUFBQSx1Q0FBaUIsRUFBQyxDQUFDLENBQUMsQ0FBQTtRQUM1QixDQUFDO0lBQ0gsQ0FBQztDQUNGLENBQUEifQ==